import { render, staticRenderFns } from "./EditMaterialModal.vue?vue&type=template&id=1d070154&scoped=true&class=fill-height&"
import script from "./EditMaterialModal.vue?vue&type=script&lang=ts&"
export * from "./EditMaterialModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditMaterialModal.vue?vue&type=style&index=0&id=1d070154&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d070154",
  null
  
)

export default component.exports